var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { MODAL_ZINDEX, SIZE_XXL } from "../helpers";
import styled from 'styled-components';
var Root = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: fixed;\n    display: flex;\n    z-index: ", ";\n    flex-direction: row;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    padding-top: ", ";\n    background: ", ";\n    justify-content: stretch;\n    flex-shrink: 0;\n    * > {\n        flex-grow: 1;\n    }\n"], ["\n    position: fixed;\n    display: flex;\n    z-index: ", ";\n    flex-direction: row;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    padding-top: ", ";\n    background: ",
    ";\n    justify-content: stretch;\n    flex-shrink: 0;\n    * > {\n        flex-grow: 1;\n    }\n"])), MODAL_ZINDEX, function (_a) {
    var isFullPage = _a.isFullPage;
    return (isFullPage ? 0 : SIZE_XXL);
}, function (_a) {
    var isFullPage = _a.isFullPage, color = _a.color;
    return color ? color : isFullPage ? '#fff' : "rgba(0,0,0, .2)";
});
export var PageViewPort = React.forwardRef(function (_a, ref) {
    var children = _a.children, isFullPage = _a.isFullPage, rest = __rest(_a, ["children", "isFullPage"]);
    return (React.createElement(Root, { ref: ref, "data-selector-id": rest['data-selector-id'], isFullPage: isFullPage, color: rest.color }, children));
});
var templateObject_1;
//# sourceMappingURL=PageViewport.js.map